//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      current: 0,
      wordList: [],
      startTime: null,
      elapsedTime: 0,
      timer: null,
      correctCount: 0,
      showSummary: false,
      wrongAnswers: [],
      book: {},
      showUnansweredAlert: false,
      loading: true
    }
  },
  computed: {
    unansweredCount () {
      return this.wordList.filter(item => !item.answered).length
    },
    formattedTime () {
      const minutes = Math.floor(this.elapsedTime / 60)
      const seconds = this.elapsedTime % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    correctRate () {
      if (!this.wordList.length) return 0
      return Math.round((this.correctCount / this.wordList.length) * 100)
    },
    progressPercent () {
      if (!this.wordList.length) return 0
      return Math.round(((this.current + 1) / this.wordList.length) * 100)
    }
  },
  mounted () {
    this.book = this.$route.query
    this.getUnitListByBookId()
    this.startTimer()
  },
  watch: {
    current () {
      this.scrollNavToCurrent()
    }
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    isValidOption (content) {
      return content != null && String(content).trim() !== ''
    },
    shuffleArray (arr) {
      const list = arr.slice()
      for (let i = list.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = list[i]
        list[i] = list[j]
        list[j] = temp
      }
      return list
    },
    buildDistractorPool (allItems, currentItem) {
      const pool = new Set()
      allItems.forEach(other => {
        if (other === currentItem) return
        if (this.isValidOption(other.answer) && other.answer !== currentItem.answer) {
          pool.add(String(other.answer).trim())
        }
        if (this.isValidOption(other.title) && other.title !== currentItem.answer && other.title !== currentItem.title) {
          pool.add(String(other.title).trim())
        }
        ;(other.children || []).forEach(c => {
          const text = c && c.content
          if (this.isValidOption(text) && text !== currentItem.answer) {
            pool.add(String(text).trim())
          }
        })
      })
      return Array.from(pool)
    },
    sanitizeQuestion (item, allItems) {
      const answer = this.isValidOption(item.answer) ? String(item.answer).trim() : ''
      const seen = new Set()
      let children = (item.children || [])
        .filter(c => this.isValidOption(c.content))
        .map(c => ({ content: String(c.content).trim() }))
        .filter(c => {
          if (seen.has(c.content)) return false
          seen.add(c.content)
          return true
        })

      if (answer && !children.some(c => c.content === answer)) {
        children.unshift({ content: answer })
        seen.add(answer)
      }

      const targetCount = 4
      if (children.length < targetCount) {
        const pool = this.shuffleArray(this.buildDistractorPool(allItems, item))
        for (const content of pool) {
          if (children.length >= targetCount) break
          if (!seen.has(content)) {
            children.push({ content })
            seen.add(content)
          }
        }
      }

      children = this.shuffleArray(children)

      return {
        ...item,
        answer,
        children
      }
    },
    sanitizeWordList (list) {
      const items = (list || []).map(item => ({ ...item }))
      return items.map(item => this.sanitizeQuestion(item, items))
    },
    scrollNavToCurrent () {
      this.$nextTick(() => {
        const container = this.$refs.questionNavBar
        if (!container) return
        const active = container.querySelector('.nav-number.current')
        if (active) {
          active.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          })
        }
      })
    },
    getNavClass (item, index) {
      const classes = []
      if (this.current === index) classes.push('current')
      if (!item.answered) {
        classes.push('unanswered')
        return classes
      }
      const selected = item.children && item.children[item.selectedIndex]
      if (selected && selected.content === item.answer) {
        classes.push('correct')
      } else {
        classes.push('wrong')
      }
      return classes
    },
    getOptionClass (item, children, index1) {
      if (!item.answered) return ''
      if (children.content === item.answer) return 'option-correct'
      if (item.selectedIndex === index1) return 'option-wrong'
      return ''
    },
    startTimer () {
      this.stopTimer()
      this.startTime = Date.now()
      this.timer = setInterval(() => {
        this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000)
      }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    jumpToQuestion (index) {
      if (index < 0 || index >= this.wordList.length) return
      this.current = index
      if (this.$refs.swiper) {
        this.$refs.swiper.swipeTo(index)
      }
    },
    handleAnswer (item, children, index1) {
      if (item.answered) return
      item.answered = true
      item.selectedIndex = index1

      const isCorrect = children.content === item.answer
      if (isCorrect) {
        this.correctCount++
        setTimeout(() => this.autoNext(), 1000)
      } else {
        this.wrongAnswers.push({
          question: item,
          selected: children.content,
          correct: item.answer
        })
      }
    },
    autoNext () {
      if (this.current < this.wordList.length - 1) {
        this.goNext()
      } else {
        this.handleFinalSubmit()
      }
    },
    handleFinalSubmit () {
      if (this.unansweredCount > 0) {
        this.showUnansweredAlert = true
        setTimeout(() => {
          this.showUnansweredAlert = false
        }, 3000)
        return
      }
      this.showSummary = true
      this.stopTimer()
    },
    goPre () {
      if (this.current > 0) {
        this.jumpToQuestion(this.current - 1)
      }
    },
    goNext () {
      if (this.current < this.wordList.length - 1) {
        this.jumpToQuestion(this.current + 1)
      }
    },
    onChange (index) {
      this.current = index
    },
    restartPractice () {
      this.wordList.forEach(item => {
        item.answered = false
        item.selectedIndex = null
      })
      this.current = 0
      this.correctCount = 0
      this.wrongAnswers = []
      this.showSummary = false
      this.showUnansweredAlert = false
      this.elapsedTime = 0
      this.startTimer()
      this.$nextTick(() => {
        if (this.$refs.swiper) {
          this.$refs.swiper.swipeTo(0)
        }
        this.scrollNavToCurrent()
      })
    },
    getUnitListByBookId () {
      const params = {
        type: 11,
        selectType: this.$route.query.type,
        id: this.$route.query.value
      }

      if (this.$route.query.cellId) {
        params.type = 1
        params.id = this.$route.query.cellId
      }

      this.loading = true
      this.$ajax.post(this.$api.pms_practice_getUnitListByBookId, params)
        .then(result => {
          let list = this.sanitizeWordList(result)
          const power = this.$route.query.isWordPower
          if ((power === 0 || power === '0') && list.length > 5) {
            list = list.slice(0, 5)
          }
          this.wordList = list.map(item => ({
            ...item,
            answered: false,
            selectedIndex: null
          }))
          this.$nextTick(() => {
            this.scrollNavToCurrent()
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    goReturn () {
      if (this.$route.query.source) {
        this.$router.push({
          path: '/practiceSelectList_display?hideTrans=true',
          query: this.$route.query
        })
      } else {
        this.$router.push('/wordIndex?hideTrans=true')
      }
    },
    goBack () {
      this.$router.push('/home?hideTrans=true')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/word/practice/practiceTable.vue